import { IRoute } from "@src/routes";
import CreateOAuth2ClientPage from "./pages/CreateOAuth2ClientPage";
import EditOAuth2ClientPage from "./pages/EditOAuth2ClientPage";
import ListOauth2ClientsPage from "./pages/ListOauth2ClientsPage";
import ViewOAuth2ClientPage from "./pages/ViewOAuth2ClientPage";

import { SsoRolesEnum } from "@funcional/react-auth-ui";

const routes: IRoute[] = [
  {
    menu: { label: "Novo Cliente de OAuth2" },
    path: "/sso/oauth2-clients/new",
    key: "SSO_OAUTH2_CLIENT_CREATE",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: CreateOAuth2ClientPage,
  },
  {
    path: "/sso/oauth2-clients/:id/edit",
    key: "SSO_OAUTH2_CLIENT_EDIT",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: EditOAuth2ClientPage,
  },
  {
    menu: { label: "Cliente de OAuth2" },
    path: "/sso/oauth2-clients/:id",
    key: "SSO_OAUTH2_CLIENT_VIEW",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: ViewOAuth2ClientPage,
  },
  {
    menu: { label: "Clientes de OAuth2" },
    path: "/sso/oauth2-clients",
    key: "SSO_OAUTH2_CLIENT_LIST",
    exact: true,
    roles: [SsoRolesEnum.MASTER],
    component: ListOauth2ClientsPage,
  },
];

export default routes;
